import { Alignment, Fit, Layout } from '@rive-app/react-canvas';

import { useRiveMachine } from '../../../../hooks/rive/useRiveMachine';
import { useStores } from '../../../../stores/useStores';

import type { RiveError } from './types';

interface RiveBannersAnimationProps {
  riveFileUrl: string;
  setRiveLoadingError: (error: RiveError) => void;
}

export const useRiveBannersAnimation = ({ riveFileUrl, setRiveLoadingError }: RiveBannersAnimationProps) => {
  const { uiStore } = useStores();

  const src = uiStore.bannerAnimationFlag ? riveFileUrl : '';

  const {
    rive,
    isLoading: isRiveLoading,
    RiveComponent,
    error,
    timeoutError,
  } = useRiveMachine({
    src,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.BottomCenter,
    }),
    onLoadError: (err: RiveError) => {
      setRiveLoadingError(err);
    },
  });

  const hasError = Boolean(error) || Boolean(timeoutError);

  if (!riveFileUrl || !uiStore.bannerAnimationFlag) return { RiveComponent, showRive: false };

  return {
    RiveComponent,
    showRive: !!riveFileUrl && !hasError,
    rive,
    isRiveLoading,
  };
};
